module.exports = __webpack_public_path__ + "fonts/BebasNeue-Regular.woff?c12b731ad0dff9fa26ceac9bdc818693";